import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedCoin = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="money" size="100%" color={stroke ?? color} />
);

export { LineRoundedCoin };
